<!-- 员工信息新增/编辑 -->
<template>
  <j-modal :title="title" size="small" :visible="visible" @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="form" :rules="rules" @keyup.enter.native="handleOk">
        <a-descriptions title="个人信息" :column="column">
          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('realname')">姓名</span>
            </template>
            <a-form-model-item prop="realname">
              <a-input v-model="form.realname" placeholder="请填写姓名" :maxLength="100" v-if="editMode" />
              <span v-else>{{ form.realname }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('phone')">联系电话</span>
            </template>
            <a-form-model-item prop="phone">
              <a-input
                v-model="form.phone"
                placeholder="请填写联系电话"
                :maxLength="45"
                v-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.phone }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('identityNo')">身份证号码</span>
            </template>
            <a-form-model-item prop="identityNo">
              <JEmpty v-if="showMask"></JEmpty>
              <a-input v-model="form.identityNo" placeholder="请填写身份证号码" :maxLength="18" v-else-if="editMode" />
              <span v-else>{{ form.identityNo }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span>生日</span>
              <j-slash></j-slash>
              <span>年龄</span>
            </template>
            <a-form-model-item prop="birthday">
              <template v-if="form.birthday">
                <span>{{ form.birthday }}</span>
                <j-slash v-if="form.age"></j-slash>
                <span v-if="form.age">{{ form.age + '岁' }}</span>
              </template>
              <j-empty v-else></j-empty>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('identityAddr')">身份证住址</span>
            </template>
            <a-form-model-item prop="identityAddr">
              <JEmpty v-if="showMask"></JEmpty>
              <a-input
                v-model="form.identityAddr"
                placeholder="请填写身份证住址"
                :maxLength="100"
                v-else-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.identityAddr }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span>性别</span>
            </template>
            <a-form-model-item prop="sex">
              <span v-if="form.sex">{{ $getDict('sex', form.sex) }}</span>
              <j-empty v-else></j-empty>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('graduateSchool')">毕业学校</span>
            </template>
            <a-form-model-item prop="graduateSchool">
              <a-input
                v-model="form.graduateSchool"
                placeholder="请填写毕业学校"
                :maxLength="100"
                v-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.graduateSchool }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('major')">专业</span>
            </template>
            <a-form-model-item prop="major">
              <a-input
                v-model="form.major"
                placeholder="请填写专业"
                :maxLength="100"
                v-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.major }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('graduateDate')">毕业时间</span>
            </template>
            <a-form-model-item prop="graduateDate">
              <a-date-picker
                v-model="form.graduateDate"
                placeholder="请选择毕业时间"
                v-if="editMode || editFromStaff"
              />
              <span v-else-if="form.graduateDate">{{ moment(form.graduateDate).format('YYYY-MM-DD') }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('education')">学历</span>
            </template>
            <a-form-model-item prop="education">
              <j-dict-select-tag
                v-model="form.education"
                dictCode="education"
                placeholder="请选择学历"
                :type="editMode || editFromStaff ? 'select' : 'label'"
              />
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('homeAddr')">现住址</span>
            </template>
            <a-form-model-item prop="homeAddr">
              <JEmpty v-if="showMask"></JEmpty>
              <a-input
                v-model="form.homeAddr"
                placeholder="请填写现住址"
                :maxLength="1000"
                v-else-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.homeAddr }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('email')">邮箱</span>
            </template>
            <a-form-model-item prop="email">
              <a-input v-model="form.email" placeholder="请填写邮箱" :maxLength="45" v-if="editMode || editFromStaff" />
              <span v-else>{{ form.email }}</span>
            </a-form-model-item>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="员工信息" :column="column">
          <a-descriptions-item>
            <template slot="label">
              <span>员工编号</span>
            </template>

            <span v-if="form.username" style="margin-right: 15px">{{ form.username }}</span>

            <!-- 系统用户 -->
            <span>
              <a-tag color="blue" v-if="form.delFlag == '0' && !form.employeeType && !form.entryDay">系统用户</a-tag>

              <!-- 离职 -->
              <template v-else-if="form.delFlag == '1' && isRetired">
                <a-tag style="margin-right: 15px">离职</a-tag>

                <template>
                  <span>离职于：</span>
                  <a-form-model-item prop="retirementDay" style="display: inline-block; width: 110px">
                    <a-date-picker v-model="form.retirementDay" placeholder="离职时间" v-if="editMode" />
                    <span v-else>{{ moment(form.retirementDay).format('YYYY-MM-DD') }}</span>
                  </a-form-model-item>
                </template>
              </template>

              <!-- 削除 -->
              <a-tag v-else-if="form.delFlag == '1' && !form.retirementDay">删除</a-tag>
              <!-- 等待入职 -->
              <a-tag color="orange" v-else-if="form.delFlag == '-1'">等待入职</a-tag>
              <!-- 即将离职 -->
              <a-tag
                color="red"
                v-else-if="
                  form.delFlag == '0' && form.retirementDay && moment(form.retirementDay).isAfter(moment(new Date()))
                "
                >即将离职</a-tag
              >
              <!-- 试用期 -->
              <a-tag color="cyan" v-else-if="!form.regularFlag">试用期</a-tag>
              <!-- 在职 -->
              <a-tag color="green" v-else>在职</a-tag>
            </span>
          </a-descriptions-item>

          <!--<a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('employeeType')">员工类型</span>
            </template>
            <a-form-model-item prop="employeeType">
              <j-dict-select-tag
                v-model="form.employeeType"
                dictCode="employeeType"
                placeholder="请选择员工类型"
                :type="editMode ? 'select' : 'label'"
              />
            </a-form-model-item>
          </a-descriptions-item>-->

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('laborRelation')">劳动关系</span>
            </template>
            <a-form-model-item prop="laborRelation">
              <j-dict-select-tag
                v-model="form.laborRelation"
                dictCode="laborRelation"
                placeholder="请选择劳动关系"
                :type="editMode || editFromStaff ? 'select' : 'label'"
              />
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('workPlace')">工作地点</span>
            </template>
            <a-form-model-item prop="workPlace">
              <a-cascader
                v-model="form.workPlace"
                :options="provinceCityOptions"
                placeholder="请选择工作地点"
                changeOnSelect
                :displayRender="renderProvinceCityCascader"
                @change="changeProvinceCity(arguments[0], arguments[1], form)"
                v-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.workAddr }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('insuranceType')">社保类型</span>
            </template>
            <a-form-model-item prop="insuranceType">
              <j-dict-select-tag
                v-model="form.insuranceType"
                dictCode="insuranceType"
                placeholder="请选择社保类型"
                :type="editMode || editFromStaff ? 'select' : 'label'"
              />
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('firstConDate')">首签合同时间</span>
            </template>
            <a-form-model-item prop="firstConDate">
              <a-range-picker v-model="form.firstConDate" placeholder="请选择首签合同时间" v-if="editMode" />
              <span v-else>
                <span v-if="form.firstConStartDate">{{ moment(form.firstConStartDate).format('YYYY-MM-DD') }}</span>
                <span style="color: rgba(0, 0, 0, 0.2); margin: 0 4px" v-if="form.firstConEndDate"> ～ </span>
                <span v-if="form.firstConEndDate">{{ moment(form.firstConEndDate).format('YYYY-MM-DD') }}</span>
              </span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('cpf')">公积金</span>
            </template>
            <a-form-model-item prop="cpf">
              <a-switch
                v-model="form.cpf"
                checked-children="有"
                un-checked-children="无"
                v-if="editMode || editFromStaff"
              />
              <span v-else>
                <span v-if="form.cpf">有</span>
                <span v-else>无</span>
              </span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('conDate')">当前合同时间</span>
            </template>
            <a-form-model-item prop="conDate">
              <a-range-picker
                v-model="form.conDate"
                placeholder="请选择当前合同时间"
                v-if="editMode || editFromStaff"
              />
              <span v-else>
                <span v-if="form.conStartDate">{{ moment(form.conStartDate).format('YYYY-MM-DD') }}</span>
                <span style="color: rgba(0, 0, 0, 0.2); margin: 0 4px" v-if="form.conEndDate"> ～ </span>
                <span v-if="form.conEndDate">{{ moment(form.conEndDate).format('YYYY-MM-DD') }}</span>
              </span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('joinLaborUnion')">是否加入工会</span>
            </template>
            <a-form-model-item prop="joinLaborUnion">
              <a-switch
                v-model="form.joinLaborUnion"
                checked-children="是"
                un-checked-children="否"
                v-if="editMode || editFromStaff"
              />
              <span v-else>
                <span v-if="form.joinLaborUnion">是</span>
                <span v-else>否</span>
              </span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('entryDay')">入职时间</span>
            </template>
            <a-form-model-item prop="entryDay">
              <a-date-picker v-model="form.entryDay" placeholder="请选择入职时间" v-if="editMode" />
              <span v-else-if="form.entryDay">{{ moment(form.entryDay).format('YYYY-MM-DD') }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('emerName')">紧急联系人姓名</span>
            </template>
            <a-form-model-item prop="emerName">
              <a-input
                v-model="form.emerName"
                placeholder="请填写紧急联系人姓名"
                :maxLength="100"
                v-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.emerName }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('regularStartDate')">转正时间</span>
            </template>
            <a-form-model-item prop="regularStartDate">
              <a-date-picker v-model="form.regularStartDate" placeholder="请选择转正时间" v-if="editMode" />
              <span v-else-if="form.regularStartDate">{{ moment(form.regularStartDate).format('YYYY-MM-DD') }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('emerPhone')">紧急联系人电话</span>
            </template>
            <a-form-model-item prop="emerPhone">
              <a-input
                v-model="form.emerPhone"
                placeholder="请填写紧急联系人电话"
                :maxLength="45"
                v-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.emerPhone }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('supervisorId')">直属上级</span>
            </template>
            <a-form-model-item prop="supervisorId">
              <j-input-popup
                v-model="selectUserList"
                component="SelectUserTreeModal"
                placeholder="请选择直属上级"
                :params="{
                  multiFlg: '0',
                  departFlg: '1',
                  selectUserList: selectUserList,
                }"
                @change="changeSelectUser"
                v-if="editMode"
              ></j-input-popup>
              <span v-else-if="selectUserList.length > 0">
                <span>{{ selectUserList[0].text }}</span>
                <JSlash></JSlash>
                <span style="font-size: 13px; color: var(--color-grey)">{{ selectUserList[0].extraTexts[0] }}</span>
              </span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('wageCardBank')">工资卡开户银行</span>
            </template>
            <a-form-model-item prop="wageCardBank">
              <JEmpty v-if="showMask"></JEmpty>
              <a-input
                v-model="form.wageCardBank"
                placeholder="请填写工资卡开户银行"
                :maxLength="100"
                v-else-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.wageCardBank }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('postLevel')">职级</span>
            </template>

            <JEmpty v-if="showMask"></JEmpty>
            <a-popover placement="topLeft" v-else-if="editMode">
              <template slot="content">
                <div>管理职：M　技术职：P　文员职：J</div>
                <div class="extraNote">数字越大级别越高，项目人员一般定级为J1</div>
              </template>
              <a-form-model-item prop="postLevel">
                <j-dict-select-tag
                  v-model="form.postLevel"
                  placeholder="请选择职级"
                  :dictCode="$getDict('postLevel')"
                />
              </a-form-model-item>
            </a-popover>

            <span v-else-if="form.postLevel">{{ $getDict('postLevel', form.postLevel) }}</span>
          </a-descriptions-item>

          <a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('wageCardBankAccount')">工资卡银行账号</span>
            </template>
            <a-form-model-item prop="wageCardBankAccount">
              <JEmpty v-if="showMask"></JEmpty>
              <a-input
                v-model="form.wageCardBankAccount"
                placeholder="请填写工资卡银行账号"
                :maxLength="100"
                v-else-if="editMode || editFromStaff"
              />
              <span v-else>{{ form.wageCardBankAccount }}</span>
            </a-form-model-item>
          </a-descriptions-item>

          <!--<a-descriptions-item>
            <template slot="label">
              <span :class="$isRequired('retirementDay')">离职时间</span>
            </template>
            <a-form-model-item prop="retirementDay">
              <j-empty v-if="!isRetired"></j-empty>
              <a-date-picker v-model="form.retirementDay" placeholder="请选择离职时间" v-else-if="editMode" />
              <span v-else>{{ moment(form.retirementDay).format('YYYY-MM-DD') }}</span>
            </a-form-model-item>
          </a-descriptions-item>-->
        </a-descriptions>

        <a-row style="margin-top: 22px">
          <a-col :span="14">
            <a-descriptions class="no-label">
              <template slot="title"
                >所属信息
                <!--<span>部门</span>
                <j-slash></j-slash>
                <span>职位</span>
                <j-slash></j-slash>
                <span>条线</span>
                <j-slash></j-slash>
                <span>职级</span>-->
              </template>

              <a-descriptions-item>
                <a-table :pagination="false" bordered :dataSource="form.relations" tableLayout="auto">
                  <a-table-column :width="46" align="center">
                    <span slot="title">#</span>
                    <template slot-scope="text, record, index">
                      {{ index + 1 }}
                    </template>
                  </a-table-column>

                  <a-table-column key="departName" data-index="departName" align="left">
                    <span slot="title" class="required">部门</span>
                    <template slot-scope="text, record, index">
                      <span>{{ form.relations[index].departName }}</span>
                    </template>
                  </a-table-column>

                  <a-table-column key="positionName" data-index="positionName" align="left">
                    <span slot="title">职位</span>
                    <template slot-scope="text, record, index">
                      <span v-if="form.relations[index].positionName">{{ form.relations[index].positionName }}</span>
                      <JEmpty v-else></JEmpty>
                    </template>
                  </a-table-column>

                  <a-table-column key="bizLineName" data-index="bizLineName" align="left">
                    <span slot="title">条线</span>
                    <template slot-scope="text, record, index">
                      <span v-if="form.relations[index].bizLineName">{{ form.relations[index].bizLineName }}</span>
                      <JEmpty v-else></JEmpty>
                    </template>
                  </a-table-column>

                  <a-table-column key="mainFlag" data-index="mainFlag" align="center" width="70px">
                    <span slot="title">主所属</span>
                    <template slot-scope="text, record">
                      <a-radio
                        v-model="record.mainFlag"
                        @change="changeMainFlag(record)"
                        v-if="editMode && form.delFlag == 0"
                      ></a-radio>
                      <a-icon type="check" v-else-if="record.mainFlag" />
                    </template>
                  </a-table-column>
                </a-table>
                <!--<p class="tips"><span>Tips：</span><span>部门职位条线的变更需提出异动申请</span></p>-->
              </a-descriptions-item>
            </a-descriptions>
          </a-col>

          <a-col :span="1"></a-col>

          <a-col :span="9">
            <a-descriptions class="no-label">
              <template slot="title">角色</template>

              <a-descriptions-item>
                <a-table :pagination="false" bordered :dataSource="form.roles" tableLayout="fixed">
                  <a-table-column :width="46" align="center">
                    <span slot="title">#</span>
                    <template slot-scope="text, record, index">
                      {{ index + 1 }}
                    </template>
                  </a-table-column>

                  <a-table-column key="roleId" data-index="roleId" align="left">
                    <span slot="title" class="required">角色名称</span>
                    <template slot-scope="text, record, index">
                      <a-form-model-item :prop="`roles.${index}.roleId`" :rules="rules.roleId">
                        <span v-if="!record.entryFlag && record.id">{{ record.roleName }}</span>
                        <j-dict-select-tag
                          v-else
                          v-model="record.roleId"
                          placeholder="请选择角色"
                          dictCode="sys_role;role_name;id;del_flag = 0 and entry_flag = true order by role_name asc"
                          :type="editMode ? 'select' : 'label'"
                        />
                      </a-form-model-item>
                    </template>
                  </a-table-column>

                  <a-table-column :width="46" align="center" v-if="editMode && form.delFlag == 0">
                    <span slot="title">
                      <i class="mdi mdi-plus" @click="addRow(form.roles)"></i>
                    </span>
                    <div slot-scope="text, record, index" style="white-space: nowrap">
                      <JEmpty v-if="!record.entryFlag && record.id" style="left: 1px"></JEmpty>
                      <a v-else @click="deleteRow(form.roles, index)">删除</a>
                    </div>
                  </a-table-column>
                </a-table>
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
        </a-row>

        <!--<a-row style="margin-top: 4px"> </a-row>-->

        <a-descriptions title="员工相关资料" :column="column" v-if="!showMask">
          <a-descriptions-item span="2">
            <template slot="label">
              <span class="inlineNote">（正反面）</span>
              <span :class="$isRequired('idCardFile')">身份证</span>
            </template>
            <a-form-model-item prop="idCardFile">
              <JEmpty v-if="!editMode && !editFromStaff && !form.idCardFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/身份证"
                v-model="form.idCardFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('bankCardFile')">银行卡扫描件</span>
            </template>
            <a-form-model-item prop="bankCardFile">
              <JEmpty v-if="!editMode && !editFromStaff && !form.bankCardFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/银行卡扫描件"
                v-model="form.bankCardFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('degreeFile')">最高学历证书</span>
            </template>
            <a-form-model-item prop="degreeFile">
              <JEmpty v-if="!editMode && !editFromStaff && !form.degreeFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/最高学历证书"
                v-model="form.degreeFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('laborContractFile')">劳动合同扫描件</span>
            </template>
            <a-form-model-item prop="laborContractFile">
              <JEmpty v-if="!editMode && !editFromStaff && !form.laborContractFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/劳动合同扫描件"
                v-model="form.laborContractFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('academicFile')">学位证明</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.academicFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/学位证明"
                v-model="form.academicFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('degreeSelectFile')">学历查询证明</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.degreeSelectFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/学历查询证明"
                v-model="form.degreeSelectFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('personalCreditFile')">个人征信报告</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.personalCreditFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/个人征信报告"
                v-model="form.personalCreditFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('backgroundCheckFile')">背景调查资料</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.backgroundCheckFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/背景调查扫描件"
                v-model="form.backgroundCheckFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('otherPractitionersFile')">其他从业资格证书</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.otherPractitionersFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/其他从业资格证书"
                v-model="form.otherPractitionersFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('physicalFile')">体检报告</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.physicalFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/体检报告"
                v-model="form.physicalFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('oldCompanyFile')">原单位离职证明</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.oldCompanyFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/原单位离职证明"
                v-model="form.oldCompanyFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>

          <a-descriptions-item span="2">
            <template slot="label">
              <span :class="$isRequired('otherFile')">其他文件</span>
            </template>
            <a-form-model-item>
              <JEmpty v-if="!editMode && !editFromStaff && !form.otherFile"></JEmpty>
              <j-upload
                v-else
                bizPath="入职手续/其他文件"
                v-model="form.otherFile"
                :disabled="!editMode && !editFromStaff"
                :showDownload="false"
                class="inline"
              ></j-upload>
            </a-form-model-item>
          </a-descriptions-item>
        </a-descriptions>
      </a-form-model>
    </a-spin>

    <template slot="footer">
      <a-button @click="handleOk" type="primary" icon="check" v-if="editMode || editFromStaff">确定</a-button>
      <a-button @click="handleCancel" type="primary" icon="close" v-else>关闭</a-button>
    </template>
  </j-modal>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'
import pcJson from '@/common/map/json/pc-code.json'

class formDef {
  username = undefined
  realname = undefined
  identityNo = undefined
  identityAddr = undefined
  birthday = undefined
  sex = undefined
  age = undefined
  education = undefined
  major = undefined
  graduateDate = undefined
  graduateSchool = undefined
  entryDay = undefined
  regularStartDate = undefined
  retirementDay = undefined
  workAddr = undefined
  workProvince = undefined
  workCity = undefined
  laborRelation = undefined
  firstConStartDate = undefined
  firstConEndDate = undefined
  firstConDate = []
  conStartDate = undefined
  conEndDate = undefined
  conDate = []
  phone = undefined
  insuranceType = undefined
  employeeType = undefined
  cpf = false
  joinLaborUnion = false
  emerName = undefined
  emerPhone = undefined
  homeAddr = undefined
  email = undefined
  wageCardBank = undefined
  wageCardBankAccount = undefined
  supervisorId = undefined
  postLevel = undefined

  idCardFile = undefined
  bankCardFile = undefined
  degreeFile = undefined
  laborContractFile = undefined
  academicFile = undefined
  degreeSelectFile = undefined
  personalCreditFile = undefined
  backgroundCheckFile = undefined
  otherPractitionersFile = undefined
  physicalFile = undefined
  oldCompanyFile = undefined
  otherFile = undefined

  relations = []
  roles = []
}

export default {
  name: 'EmployeeModal',
  mixins: [tableMixin],
  components: {
  },
  props: {},
  data() {
    return {
      title: '',
      visible: false,
      loading: false,
      editMode: false,
      editFromStaff: false,
      showMask: false,
      isRetired: false,
      form: new formDef(),
      selectUserList: [],
      // 省市json
      provinceCityOptions: pcJson,
      workPlace: [],
      rules: {
        realname: [this._r.required],
        phone: [this._r.required],
        identityNo: [
          this._r.required,
          {
            validator: (rule, value, callback) => {
              if (checkIdentityNo(value)) {
                callback()
              } else {
                callback('请填写正确的身份证号码')
              }
            },
            trigger: 'blur',
          },
        ],
        identityAddr: [this._r.required],
        employeeType: [this._r.required],
        laborRelation: [this._r.required],
        insuranceType: [this._r.required],
        //cpf: [this._r.required],
        //joinLaborUnion: [this._r.required],
        entryDay: [this._r.required],
        regularStartDate: [this._r.required],
        retirementDay: [],
        firstConDate: [this._r.required],
        conDate: [this._r.required],
        workPlace: [this._r.required],
        emerName: [this._r.required],
        emerPhone: [this._r.required],
        homeAddr: [this._r.required],
        //email: [this._r.required],
        education: [this._r.required],
        major: [this._r.required],
        graduateDate: [this._r.required],
        graduateSchool: [this._r.required],
        supervisorId: [this._r.required],
        postLevel: [this._r.required],
        roleId: [this._r.required],
        //idCardFile: [this._r.required],
        //bankCardFile: [this._r.required],
        //degreeFile: [this._r.required],
      },
      url: {
        submit: '/EmployeeManage/submit',
      },
    }
  },
  watch: {
    'form.identityNo': {
      handler(newVal, oldVal) {
        if (newVal) {
          newVal = newVal.toString()
          if (newVal.length != 18) {
            return
          }

          var year = newVal.substring(6, 10)
          var month = newVal.substring(10, 12)
          var day = newVal.substring(12, 14)
          var sex = newVal.substring(16, 17)

          this.form.birthday = moment(year + month + day).format('YYYY-MM-DD')
          this.form.age = calcAge(moment(year + month + day))
          this.form.sex = sex % 2 == 0 ? '2' : '1'
        } else {
          this.form.birthday = ''
          this.form.age = ''
          this.form.sex = ''
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() {},
  methods: {
    add() {
      this.edit({}, true, true)
    },
    async edit(record, isAdd, editMode, editFromStaff) {
      this.visible = true
      this.editMode = editMode
      this.editFromStaff = editFromStaff

      // 使用form定义初始化form
      this.form = new formDef()

      // 新增
      if (isAdd) {
      }
      // 编辑
      else {
        if (this.loading) {
          return
        } else {
          this.loading = true
        }

        Object.assign(this.form, record)

        this.form.id = record.id
        this.form.firstConDate.push(this.form.firstConStartDate)
        this.form.firstConDate.push(this.form.firstConEndDate)
        this.form.conDate.push(this.form.conStartDate)
        this.form.conDate.push(this.form.conEndDate)
        this.form.roles = XEUtils.clone(record.roles, true)

        if (this.form.workProvince) {
          Vue.set(this.form, 'workPlace', [])
          this.form.workPlace.push(this.form.workProvince)
          this.form.workPlace.push(this.form.workCity)
        }

        if (this.form.supervisorId) {
          var supervisor = await this.$getSysUser(this.form.supervisorId)

          if (supervisor) {
            this.selectUserList = [
              {
                value: supervisor.id,
                text: supervisor.realname,
                extraTexts: [supervisor.username],
              },
            ]
          }
        } else {
          this.selectUserList = []
        }

        if (record.cpf) {
          this.form.cpf = true
        } else {
          this.form.cpf = false
        }

        if (record.joinLaborUnion) {
          this.form.joinLaborUnion = true
        } else {
          this.form.joinLaborUnion = false
        }

        // 已有离职日期的时候说明该员工已离职,则离职日期为必填不可清空
        if (this.form.retirementDay) {
          this.isRetired = true
          this.rules.retirementDay = [this._r.required]
        } else {
          this.isRetired = false
          this.rules.retirementDay = []
        }

        var sb = new StringBuilder()
        sb.append(' WHERE DEL_FLAG = 0 ')
        sb.append(" AND USER_ID = '" + this.form.id + "'")
        sb.append(' ORDER BY ORG_CODE, POSITION_ID, POST_LEVEL, BIZ_LINE_ID')
        this.form.relations = await this.$query('v_sys_user_depart_position', sb.toString())

        this.loading = false
      }
    },
    handleOk() {
      // 表单验证
      this.$refs.form.validateFieldsAndScroll((ok) => {
        // 验证成功
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          if (this.form.firstConDate.length > 0) {
            this.form.firstConStartDate = this.form.firstConDate[0]
            this.form.firstConEndDate = this.form.firstConDate[1]
          } else {
            this.form.firstConStartDate = ''
            this.form.firstConEndDate = ''
          }

          if (this.form.conDate.length > 0) {
            this.form.conStartDate = this.form.conDate[0]
            this.form.conEndDate = this.form.conDate[1]
          } else {
            this.form.conStartDate = ''
            this.form.conEndDate = ''
          }

          postAction(this.url.submit, this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success('处理成功')
                this.visible = false
                this.$emit('ok')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    importFromTalentBank(talentBank) {
      talentBank.id = this.form.id
      Object.assign(this.form, talentBank)
      this.$refs.form.clearValidate()
    },
    disabledDate(current) {
      // 入职日期只能选择今天或今天之后的日期
      return current && moment(current).format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD')
    },
    changeSelectUser(selected) {
      if (selected.length == 0) {
        this.form.supervisorId = ''
      } else {
        this.form.supervisorId = selected[0].value
        this.selectUserList[0].extraTexts = [selected[0].username]
      }
    },
    changeMainFlag(selected) {
      this.form.relations.forEach((r) => {
        r.mainFlag = false
      })
      selected.mainFlag = true
    },
    renderProvinceCityCascader({ labels, selectedOptions }) {
      if (selectedOptions.length > 1) {
        return (
          <span>
            <span>{selectedOptions[0].label}</span>
            <JSlash></JSlash>
            <span>{selectedOptions[1].label}</span>
          </span>
        )
      } else if (selectedOptions.length > 0) {
        return <span>{selectedOptions[0].label}</span>
      } else {
        return null
      }
    },
    changeProvinceCity(value, selectedOptions, record) {
      if (selectedOptions) {
        record.workProvince = selectedOptions[0].value
        record.workAddr = selectedOptions[0].label
        if (selectedOptions.length > 1) {
          record.workCity = selectedOptions[1].value
          record.workAddr = selectedOptions[0].label + selectedOptions[1].label
        } else {
          record.workCity = undefined
        }
      } else {
        record.workProvince = undefined
        record.workCity = undefined
      }
    },
  },
}
</script>

<style scoped lang="less">
.anticon-star:hover {
  transform: scale(1.15);
}

.anticon-check {
  font-size: 16px;
  transition: all 0.3s;
  color: var(--color-green);
  position: relative;
  top: 1px;
}

/deep/ .extraTexts {
  font-size: 13px;
  color: var(--color-grey);
}
</style>
